import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Dropdown,
  Menu,
} from 'semantic-ui-react';
import { replace } from 'react-router-redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { fetchM } from '../../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../../actions/flash';
import PictureList from '../../../components/PictureList';
import NavBar from '../../../components/NavBar';
import AddPicture from '../../modals/AddPicture';
import ViewLarge from '../../modals/ViewLarge';
import RemovePicture from '../../modals/RemovePicture';
import { editRoutes } from '../navigations';
import config from '../../../../config';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';

class Pictures extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    pictureToken: PropTypes.string,
    id: PropTypes.string,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    data: PropTypes.shape({
      name: PropTypes.string,
    }),
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        lawyerIsEnabled: PropTypes.bool,
      }),
    }),
    auth: PropTypes.shape({
      company: PropTypes.object,
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const loading = props.loading;
    const menuIsTab = window.innerWidth <= 590;
    return {
      loading,
      menuIsTab,
    };
  }
  constructor(props) {
    super(props);
    const state = Pictures.getPropsToState(props);
    this.state = {
      ...state,
      pictures: [],
      showConfirm: false,
      showLarge: false,
      selectedPicture: null,
      showAddPicture: false,
    };
    this.pictureList = null;
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = Pictures.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  handleResize = () => {
    const menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== this.state.menuIsTab) {
      this.setState({ menuIsTab });
    }
  }
  handleRefetch() {
    this.setState({
      selectedPicture: null,
    });
    if (this.pictureList) {
      this.pictureList.getWrappedInstance().handleRefetch();
    }
  }
  updatePicture() {
    const { t } = this.props;
    const { store } = this.context;
    store.dispatch(fetchM(`/projects/${this.props.id}/pictures/${this.state.selectedPicture.id}/`, {
      credentials: 'include',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': this.props.pictureToken,
      },
      body: JSON.stringify({ isCover: true }),
    }))
      .then(() => {
        this.handleRefetch();
        store.dispatch(flashSuccessMessage({ header: t('Update Success', { ns: TRANSLATION_FILES.translation }), message: t('Picture successfully updated', { ns: TRANSLATION_FILES.translation }) }));
      })
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      });
  }
  addPicture(type) {
    const { t } = this.props;
    const { store } = this.context;
    store.dispatch(fetchM(`/projects/${this.props.id}/pictures/${this.state.selectedPicture.id}/`, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': this.props.pictureToken,
      },
      body: JSON.stringify({ type }),
    }))
      .then(() => {
        this.pictureModal.handleRefetch();
        store.dispatch(flashSuccessMessage({ header: t('Add Picture Success', { ns: TRANSLATION_FILES.translation }), message: t('Picture successfully added to project', { ns: TRANSLATION_FILES.translation }) }));
      })
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      });
  }
  deletePicture() {
    const { t } = this.props;
    const { store } = this.context;
    store.dispatch(fetchM(`/projects/${this.props.id}/pictures/${this.state.selectedPicture.id}/`, {
      credentials: 'include',
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': this.props.pictureToken,
      },
    }))
      .then(() => {
        this.handleRefetch();
        store.dispatch(flashSuccessMessage({ header: t('Remove Success', { ns: TRANSLATION_FILES.translation }), message: t('Picture successfully removed', { ns: TRANSLATION_FILES.translation }) }));
      })
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      });
  }
  handleCancelRemove = (e) => {
    e.preventDefault();
    this.setState({
      showConfirm: false,
      selectedPicture: null,
    });
  }
  handleRemove = (e, selectedPicture) => {
    e.preventDefault();
    this.setState({
      selectedPicture,
    }, () => {
      this.setState({
        showConfirm: true,
      });
    });
  }
  handleConfirmRemove = (e) => {
    e.preventDefault();
    this.setState({
      showConfirm: false,
    }, () => {
      this.deletePicture();
    });
  }
  handleCloseLarge = (e) => {
    e.preventDefault();
    this.setState({
      showLarge: false,
      selectedPicture: null,
    });
  }
  handleViewLarge = (e, selectedPicture) => {
    e.preventDefault();
    this.setState({
      selectedPicture,
      showLarge: true,
    });
  }
  handleSetCover = (e, selectedPicture) => {
    e.preventDefault();
    this.setState({
      selectedPicture,
    }, () => {
      this.updatePicture();
    });
  }
  handleShowAddPicture = (e) => {
    e.preventDefault();
    this.setState({
      showAddPicture: true,
    });
  }
  handleCloseAddPicture = (e) => {
    if (e) { e.preventDefault(); }
    this.handleRefetch();
    this.setState({
      showAddPicture: false,
    });
  }
  handleAddPicture = (e, selectedPicture, pictureType) => {
    e.preventDefault();
    this.setState({
      selectedPicture,
    }, () => {
      this.addPicture(pictureType);
    });
  }
  handleUpload = body => ({
    url: `/projects/${this.props.id}/pictures/`,
    options: {
      credentials: 'include',
      method: 'POST',
      headers: {
        // Let browser decide Content-Type
        'X-Csrf-Token': this.props.pictureToken,
      },
      body,
    },
  })
  handleCheck = (data) => {
    if (data.projects && data.projects.length > 0) {
      return data.projects.some(p => p.projectID === this.props.id);
    }
    return false;
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    if (value.includes(config.get('developerURL'))) {
      e.preventDefault();
      window.location.href = value;
    } else {
      store.dispatch(replace(value));
    }
  }
  handleTypeChange = (e, { value }) => {
    const projectPictureType = value;
    this.setState({ projectPictureType });
  }
  handleGetPictures = (pictures) => {
    this.setState({ pictures });
  }
  handleSlidePicture = (e, direction = 'right') => {
    const { pictures, selectedPicture } = this.state;
    const index = pictures.indexOf(selectedPicture);
    const nextIndex = direction === 'left' ? index - 1 : index + 1;
    this.setState({
      selectedPicture: pictures[nextIndex],
    });
  }
  checkDisabled(direction = 'right') {
    const { pictures, selectedPicture } = this.state;
    if (selectedPicture) {
      const index = pictures.indexOf(selectedPicture);
      if (direction === 'left') {
        return index - 1 >= 0;
      }
      return index + 1 < pictures.length;
    }
    return false;
  }
  render() {
    const { auth, id, location, t } = this.props;
    const { pathname } = location;
    const companyServiceID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
    const isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    const links = editRoutes(id, this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled, isMalaysia, companyServiceID).map(l => ({
      ...l,
      text: t(l.text, { ns: l.text === 'Edit' ? TRANSLATION_FILES.translation : TRANSLATION_FILES.screens }),
    }));
    return (
      <Container>
        <NavBar
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={link.text}
                active={pathname === link.value}
                onClick={e => this.handleMenu(e, link)}
              />
            ))
          }
          rightNav={
            <Menu.Item fitted>
              <Button
                onClick={this.handleShowAddPicture}
                disabled={this.state.loading}
                primary
                icon="add"
                content={t('add', { ns: TRANSLATION_FILES.screens })}
              />
            </Menu.Item>
          }
        />
        <AddPicture
          type="project"
          ref={(ref) => { this.pictureModal = ref; }}
          open={this.state.showAddPicture}
          onClose={this.handleCloseAddPicture}
          onConfirm={this.handleAddPicture}
          onUpload={this.handleUpload}
          onCheck={this.handleCheck}
        />
        <ViewLarge
          open={this.state.showLarge}
          onClose={this.handleCloseLarge}
          picture={this.state.selectedPicture}
          onSlide={this.handleSlidePicture}
          disabledLeft={!this.checkDisabled('left')}
          disabledRight={!this.checkDisabled('right')}
          slideshow={this.state.showLarge}
        />
        <RemovePicture
          open={this.state.showConfirm}
          onClose={this.handleCancelRemove}
          onConfirm={this.handleConfirmRemove}
          picture={this.state.selectedPicture}
          data={this.props.data}
        />
        <PictureList
          ref={(ref) => { this.pictureList = ref; }}
          toggleable
          projectID={this.props.id}
          onChange={this.handleGetPictures}
          onViewLarge={this.handleViewLarge}
          onRemove={this.handleRemove}
          buttonNode={({ isMobile, view, loading, picture }) => {
            const isCover = picture.projects.length > 0 &&
              picture.projects[0].isCover;
            return (
              view === 'list' ? (
                <div>
                  <Button
                    compact size="tiny"
                    primary={!isCover}
                    positive={isCover}
                    icon="checkmark"
                    content={isCover ? t('Already set', { ns: TRANSLATION_FILES.translation }) : t('Set cover', { ns: TRANSLATION_FILES.translation })}
                    disabled={isCover || loading}
                    onClick={e => this.handleSetCover(e, picture)}
                  />
                  <Button
                    size="tiny"
                    compact
                    negative
                    icon="remove"
                    content={isMobile ? null : t('Remove', { ns: TRANSLATION_FILES.translation })}
                    disabled={loading}
                    onClick={e => this.handleRemove(e, picture)}
                  />
                </div>
              ) : (
                <Button
                  compact size="small"
                  attached="bottom"
                  primary={!isCover}
                  positive={isCover}
                  icon="checkmark"
                  content={isCover ? t('Already set', { ns: TRANSLATION_FILES.translation }) : t('Set cover', { ns: TRANSLATION_FILES.translation })}
                  disabled={isCover || loading}
                  onClick={e => this.handleSetCover(e, picture)}
                />
              )
            );
          }}
        />
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(Pictures.mapStateToProps)(Pictures));



// WEBPACK FOOTER //
// ./src/containers/Project/Pictures/List.jsx